module.exports = __webpack_public_path__ + "f48fdec4ba1d83d2cd99147ed4b07ac5.MP3";